// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".divBox[data-v-17b2affe] {\n  padding: 20px;\n}", ""]);
// Exports
module.exports = exports;
